import { ProductInfoComponent } from '../components/ProductInfoComponent';
/**
 * @param {Entity} entity - an entity
 * @returns {ProductInfoComponent | null} the ProductInfoComponent for the entity if it exists (or null)
 */
export const getProductInfoComponent = (entity) => entity.getComponent(ProductInfoComponent.id) ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {string | null} global article number for the given entity according to the corresponding ProductInfoComponent if it exists (or null)
 */
export const getGlobalArticleNumber = (entity) => getProductInfoComponent(entity)?.globalArticleNbr ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {ProductType | null} productType for the given entity according to the corresponding ProductInfoComponent if it exists, or null
 */
export const getProductType = (entity) => getProductInfoComponent(entity)?.productType || null;
/**
 *
 * @param entity an entity
 * @param productType a product type
 * @returns true if the entity is of the given product type, false otherwise
 */
export const isProductType = (entity, productType) => getProductType(entity) === productType;
/**
 * @param entity an entity
 * @param productType a list of product types
 * @returns true if the entity is one of the given product types
 */
export const isOneOfProductTypes = (entity, productType) => productType.includes(getProductType(entity));
/**
 * @param {Entity} entity - an entity
 * @returns {ProductType | null} design for the given entity according to the corresponding ProductInfoComponent if it exists, or null
 */
export const getProductDesign = (entity) => getProductInfoComponent(entity)?.design || null;
//# sourceMappingURL=product-info-entity-utils.js.map